import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const twoFactorApi = createApi({
  reducerPath: "twoFactorApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["TwoFactor"],
  endpoints: (builder) => ({
    get2FAStatus: builder.query({
      query: () => "/2fa/status",
      providesTags: ["TwoFactor"],
    }),
    setup2FA: builder.mutation({
      query: () => ({ url: "/2fa/setup", method: "POST" }),
    }),
    verifySetup2FA: builder.mutation({
      query: (data) => ({ url: "/2fa/verify-setup", method: "POST", body: data }),
      invalidatesTags: ["TwoFactor"],
    }),
    verify2FA: builder.mutation({
      query: (data) => ({ url: "/2fa/verify", method: "POST", body: data }),
    }),
    resend2FACode: builder.mutation({
      query: (data) => ({ url: "/2fa/resend", method: "POST", body: data }),
    }),
    sendDisableCode: builder.mutation({
      query: () => ({ url: "/2fa/send-disable-code", method: "POST" }),
    }),
    disable2FA: builder.mutation({
      query: (data) => ({ url: "/2fa/disable", method: "POST", body: data }),
      invalidatesTags: ["TwoFactor"],
    }),
  }),
});

export const {
  useGet2FAStatusQuery,
  useSetup2FAMutation,
  useVerifySetup2FAMutation,
  useVerify2FAMutation,
  useResend2FACodeMutation,
  useSendDisableCodeMutation,
  useDisable2FAMutation,
} = twoFactorApi;
